import React from 'react';
import { Button } from 'gatorcomponents';
import * as Styles from './PopoverContent.styles';

const PopoverContent = ({
  title, description, buttonLabel,
}) => (
  <Styles.GuidePopoverContent>
    {title && <Styles.GuidePopoverTitle>{title}</Styles.GuidePopoverTitle>}
    {description && <Styles.GuidePopoverDescription>{description}</Styles.GuidePopoverDescription>}
    {buttonLabel && <div><Button label={buttonLabel} width="fit-content" size="medium2" /></div>}
  </Styles.GuidePopoverContent>
);

export default PopoverContent;
